
export const paramsConf = [
    {
        show: true,
        name: 'Compte',
        type: 'accounts',
        icon: 'user',
    },
    {
        show: true,
        name: 'Configuration',
        type: 'configs',
        icon: 'cog'
    },
    {
        show: true,
        name: 'Paramètres',
        type: 'settings',
        icon: 'wrench'
    },
    {
        show: sessionStorage.getItem('rules') === 'superadmin' ? true : false,
        name: 'Table',
        type: 'tables',
        icon: 'table'
    },
    {
        show: sessionStorage.getItem('rules') === 'superadmin' ? true : false,
        name: 'Forms',
        type: 'dataforms',
        icon: 'file'
    },
    {
        show: sessionStorage.getItem('rules') === 'superadmin' ? true : false,
        name: 'Icon',
        type: 'admin/icons',
        icon: 'donate-blood'
    }
]